<template>
  <div class="mood">

  </div>
</template>

<script>
  import { Message } from '@/bot-engine.es5.js'
  import { emojiForMood } from '@/utilities.js'

  export default {
      name: 'Mood',
      props: {
        message: {
          type: Message
        }
      },
      data() {
        return {
        }
      },
      computed: {
        avatar() {
          return emojiForMood(this.message.options.state)
        }
      }
  }
</script>

<style scoped>
  .mood {
    font-size: 500%;
  }
</style>